import { ILog } from "@ihr-radioedit/inferno-core";
import { Store, isWindowDefined } from "@inferno/renderer-shared-core";
import { getUserFromCookie } from "./cookie_parser";

const log = ILog.logger("client/visibility_listener.ts");

/**
 * Detects when user returns to tab after authentication in a new tab
 * and refreshes session state to update UI accordingly (only enabled for IHR sessions not PWS)
 */
export function setupVisibilityListener(store: Store, no3rdParty: boolean) {
  if (
    !isWindowDefined() ||
    no3rdParty ||
    !store.session.currentSession ||
    store.session.currentSession.name !== "ihr-auth"
  ) {
    log.debug("Visibility listener not initialized");
    return;
  }

  const controller = new AbortController();
  let lastVisibilityChange = 0;
  const THROTTLE_INTERVAL = 2000;

  const handleVisibilityChange = () => {
    if (document.visibilityState !== "visible") {
      return;
    }

    const now = Date.now();
    if (now - lastVisibilityChange < THROTTLE_INTERVAL) {
      log.debug("Visibility change throttled");
      return;
    }
    lastVisibilityChange = now;

    log.debug("Tab became visible, checking auth state");

    const cookieUser = getUserFromCookie();
    const currentSession = store.session.currentSession;

    if (!currentSession) {
      log.debug("No current session, skipping check");
      return;
    }

    const currentState = currentSession.state;

    const cookieAuthenticated = cookieUser !== null && cookieUser.profile?.profileId !== undefined;
    const currentAuthenticated = currentState.authenticated;

    if (cookieAuthenticated !== currentAuthenticated) {
      log.debug(
        `Auth state changed (cookie: ${cookieAuthenticated}, current: ${currentAuthenticated}), refreshing session`,
      );
      currentSession.refresh().catch(err => log.error("Visibility listener session refresh failed", err));
    } else {
      log.debug("Auth state unchanged, skipping API call");
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange, {
    signal: controller.signal,
  });

  log.debug("Visibility listener initialized");

  return () => {
    controller.abort();
  };
}
